import handler from "../../iview/checkbox/handler";
import render from "./render";

const name = "checkbox";

export default {handler, render, name};
